import React from "react";
import { Flex, message, Progress } from "antd";
import logo from "./Assets/logo.webp";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import consts from "./consts";
import Axios from "./Axios";
const AuthPage = () => {
  const { token } = useParams(); // token from the URL
  console.log(token, "token"); // will log whatever is in /Authpage/<token>

  const [percent, setPercent] = useState(15); // start at 15%
  const navigate = useNavigate();
  useEffect(() => {
    if (percent >= 100) {
      navigate("/");
    }

    const interval = setInterval(() => {
      if (percent >= 50) {
        setPercent((prev) => {
          if (prev >= 100) {
            clearInterval(interval);
            return 100;
          }
          return prev + 1; // increase by 1% per tick
        });
      }
    }, 50); // every 50ms, adjust speed as needed

    return () => clearInterval(interval);
  }, [percent]);

  const getUserToken = async () => {
    try {
      const payload = {
        user_id: token,
      };
      const { data } = await Axios.post("/get-user-token", payload);
      if (data?.success) {
        localStorage.setItem("nzanzi", data?.result?.token);
        setPercent(50);
      } else {
        // message.error("Authentication failed. Please try again.");
        localStorage.removeItem("nzanzi");
        window.location.href = data?.result;
        navigate("/")
      }
    } catch (error) {
      localStorage.removeItem("nzanzi");
      // message.error("Authentication failed. Please try again.");
      window.location.href = error?.response?.data?.result;
      navigate("/")
    }
  };
  // const validateAccessToken = async () => {
  //     try {
  //         const { data } = await axios.post(`${consts.CRM_URL}/binarytrading/userAccess`, { token: token });
  //         if (Number(data.result) === 1) {
  //             setPercent(25);
  //             getUserToken();
  //         } else {
  //             navigate("/")
  //         }
  //     } catch (e) {
  //         navigate("/")
  //     }
  // };

  useEffect(() => {
    getUserToken();
  }, []);

  return (
    <div className="auth-page" style={{ background: "var(--bg-mn)" }}>
      <img src={logo} className="glow-logo" alt="Logo" style={{ height: 30, width: "auto" }} />

      <Flex vertical gap="small" style={{ width: 160 }} className="mt-20">
        <Progress
          percent={percent}
          size="small"
          strokeColor={"rgb(49, 202, 49)"}
        />
      </Flex>
      <div className="auth-txt">Authentication...</div>
    </div>
  );
};

export default AuthPage;
